<div class="mileage-rates-rules-list">
  <div class="rates-header">
    <div style="width: 200px;">
      <label for="distanceUnit">Default Distance Unit</label>
      <app-dropdown-input #distanceUnitSelect id="distanceUnit" [options]="distanceUnits"
        placeholder="Select distance unit"></app-dropdown-input>
    </div>

    <app-button text="+ Add Rule" variant="info" (clicked)="showCreateMileageRateRuleModal()" />
  </div>
  <app-trial-policy-mileage-rates-list [mileageRateRules]="mileageRateRules" (updateRule)="openUpdateRuleModal($event)">
  </app-trial-policy-mileage-rates-list>
  <div class="rates-footer">
    <app-button text="Cancel" variant="secondary" [href]="'/trial/' + trialId" />
    <app-button text="Save" [isBusy]="saveProcessing" (clicked)="saveDefaultCurrency()" />
  </div>
</div>

<app-create-mileage-rate-rule-modal [policyId]="policyId" (ruleAdded)="getMileageRatesRules()"
  #createMileageRatesRuleModal>
</app-create-mileage-rate-rule-modal>

<app-update-mileage-rate-rule-modal (ruleUpdated)="getMileageRatesRules()" #updateMileageRatesRuleModal>
</app-update-mileage-rate-rule-modal>
